// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__13BHD","validationTips":"StatementDescriptor_validationTips__24Axc"};